import { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import { useFormik } from "formik";
import useLogs from "hooks/logs";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

export default function FormMenuDialog({
  open,
  formType,
  onClose,
  selectedMenu,
}) {
  const [submitting, setSubmitting] = useState(false);
  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const deleteMenu = async (idMenu) => {
    setSubmitting(true);

    await Api.deleteParams(
      "delete-menu",
      "adminportal",
      "?idMenu=" + idMenu.toString(),
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(`Menu excluído com sucesso!`, {
            severity: "success",
          });
          setSubmitting(false);
          handleClose({ IdMenu: idMenu });
        } else {
          snackbar.showMessage("Ocorreu um erro ao deletar o menu.", {
            severity: "error",
          });
          setSubmitting(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setSubmitting(false);
        setLocalStorageApiProblem({
          idMenuAccess: "56",
          screen: "Menus",
          problem: `Erro na chamada do endpoint delete-menu - ${error}`,
        });
      });
  };

  const submit = async (values) => {
    const { nome, nomeInterno, sistema, ...otherParams } = values;

    setSubmitting(true);

    if (formType === "delete") {
      return deleteMenu(selectedMenu?.IdMenu);
    }

    return await Api.postParams(
      formType === "edit" ? "update-menu" : "create-menu",
      "adminportal",
      "?nome=" +
        nome +
        "&nomeInterno=" +
        nomeInterno +
        "&sistema=" +
        sistema +
        "&idMenuPai=" +
        (otherParams.idMenuPai.toString().length > 0
          ? otherParams.idMenuPai
          : 0
        ).toString() +
        "&viewMenu=" +
        otherParams.viewMenu.toString() +
        "&sessaoMenu=" +
        otherParams.sessaoMenu.toString() +
        "&ativo=" +
        otherParams.ativo.toString() +
        (selectedMenu?.IdMenu
          ? "&idMenu=" + selectedMenu.IdMenu.toString()
          : ""),
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(
            `Menu ${formType === "edit" ? "editado" : "criado"} com sucesso!`,
            {
              severity: "success",
            }
          );
          setSubmitting(false);
          handleClose(res.Result);
        } else {
          snackbar.showMessage(
            `Ocorreu um erro ao ${
              formType === "edit" ? "editar" : "criar"
            } o menu. Verifique os parâmetros informados.`,
            {
              severity: "error",
            }
          );
          setSubmitting(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setSubmitting(false);
        setLocalStorageApiProblem({
          idMenuAccess: "56",
          screen: "Menus",
          problem: `Erro na chamada do endpoint ${
            formType === "edit" ? "update-menu" : "create-menu"
          } - ${error}`,
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      nome: selectedMenu?.Nome || "",
      nomeInterno: selectedMenu?.NomeInterno || "",
      sistema: selectedMenu?.Sistema || "PORTALB2B",
      idMenuPai: selectedMenu?.IdMenuPai || "",
      viewMenu: selectedMenu?.ViewMenu || false,
      sessaoMenu: selectedMenu?.SessaoMenu || false,
      ativo: selectedMenu?.Ativo || false,
    },
    onSubmit: submit,
  });

  const { values, handleChange, handleSubmit, dirty, resetForm } = formik;

  const handleClose = (updatedMenu) => {
    resetForm();
    onClose(updatedMenu);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            <span>
              <Typography id="alert-dialog-title" variant="h3" component="h3">
                {`${
                  formType === "edit"
                    ? "Editar"
                    : formType === "delete"
                    ? "Excluir"
                    : "Criar"
                } Menu`}
              </Typography>
            </span>
          </DialogTitle>
          <PerfectScrollbar>
            <DialogContent style={{ padding: "1rem 1.5rem 1.5rem" }}>
              {formType === "delete" ? (
                <Typography id="alert-dialog-description" variant="h4">
                  Confirmar exclusão do Menu?
                </Typography>
              ) : (
                <>
                  <Grid container>
                    <Grid item xs={12}>
                      <FormGroup>
                        <FormLabel>Nome *</FormLabel>
                        <TextField
                          name="nome"
                          required
                          fullWidth
                          disabled={submitting}
                          value={values.nome}
                          variant="outlined"
                          onChange={handleChange}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 100);
                          }}
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                      <FormGroup>
                        <FormLabel>Nome Interno *</FormLabel>
                        <TextField
                          name="nomeInterno"
                          required
                          fullWidth
                          disabled={submitting}
                          value={values.nomeInterno}
                          variant="outlined"
                          onChange={handleChange}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 50);
                          }}
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                      <AutoCompleteField
                        label="Sistema"
                        required
                        disabled={submitting}
                        value={
                          [
                            { value: "APP", label: "APP" },
                            { value: "PORTALB2B", label: "B2B" },
                            { value: "PRATINF", label: "PD" },
                          ].find((opt) => opt.value === values.sistema) || null
                        }
                        onChange={(option) =>
                          handleChange({
                            target: {
                              name: "sistema",
                              value: option?.value || "",
                            },
                          })
                        }
                        options={[
                          { value: "APP", label: "APP" },
                          { value: "PORTALB2B", label: "B2B" },
                          { value: "PRATINF", label: "PD" },
                        ]}
                        optionLabelKey="label"
                        optionIdKey="value"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormGroup>
                        <FormLabel>IdMenuPai</FormLabel>
                        <TextField
                          name="idMenuPai"
                          type="number"
                          fullWidth
                          disabled={submitting}
                          value={values.idMenuPai}
                          variant="outlined"
                          onChange={handleChange}
                          inputProps={{ min: 0 }}
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                      <FormGroup row style={{ marginBottom: 0 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.viewMenu}
                              onChange={handleChange}
                              name="viewMenu"
                              color="primary"
                            />
                          }
                          label={<FormLabel>ViewMenu</FormLabel>}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.sessaoMenu}
                              onChange={handleChange}
                              name="sessaoMenu"
                              color="primary"
                            />
                          }
                          label={<FormLabel>SessaoMenu</FormLabel>}
                        />
                        {formType === "edit" && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.ativo}
                                onChange={handleChange}
                                name="ativo"
                                color="primary"
                              />
                            }
                            label={<FormLabel>Ativo</FormLabel>}
                          />
                        )}
                      </FormGroup>
                    </Grid>
                  </Grid>
                </>
              )}
              {submitting && (
                <div
                  style={{ marginTop: formType === "delete" ? "2rem" : "1rem" }}
                >
                  <span>{`${
                    formType === "create"
                      ? "Criando"
                      : formType === "edit"
                      ? "Editando"
                      : "Deletando"
                  } menu...`}</span>
                  <LinearProgress />
                </div>
              )}
            </DialogContent>
          </PerfectScrollbar>
          <DialogActions>
            <Button component={Box} onClick={handleClose} disabled={submitting}>
              Cancelar
            </Button>
            {formType === "delete" ? (
              <Button
                color="default"
                variant="contained"
                type="submit"
                disabled={submitting}
              >
                Confirmar
              </Button>
            ) : (
              <Button
                color="default"
                variant="contained"
                type="submit"
                disabled={
                  submitting ||
                  !dirty ||
                  MaskAndValid.isNullOrEmpty(values.nome) ||
                  MaskAndValid.isNullOrEmpty(values.nomeInterno) ||
                  MaskAndValid.isNullOrEmpty(values.sistema)
                }
              >
                {formType === "edit" ? "Atualizar" : "Criar"}
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
